import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from './config.service';
import {
    ApiErrorLogListItem,
    ApiErrorLogEntry,
    ApiErrorLogSearchRequest,
    ApiErrorLogSearchResult
} from './api-error-log.service';
import { ApiResponse } from '../shared/models';

@Injectable({ providedIn: 'root' })
export class EPortalApiLogService {
    private apiUrl: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.apiUrl = `${this.configService.get('apiBaseUrl')}/EPortalApiLog`;
    }

    getRecent(count: number = 15): Observable<ApiResponse<ApiErrorLogListItem[]>> {
        return this.http.get<ApiResponse<ApiErrorLogListItem[]>>(`${this.apiUrl}/GetRecent?count=${count}`).pipe(
            map(response => response)
        );
    }

    search(request: ApiErrorLogSearchRequest): Observable<ApiResponse<ApiErrorLogSearchResult>> {
        return this.http.post<ApiResponse<ApiErrorLogSearchResult>>(`${this.apiUrl}/Search`, request).pipe(
            map(response => response)
        );
    }

    getById(id: number): Observable<ApiResponse<ApiErrorLogEntry>> {
        return this.http.get<ApiResponse<ApiErrorLogEntry>>(`${this.apiUrl}/GetById/${id}`).pipe(
            map(response => response)
        );
    }
}
